import React, { useEffect } from 'react';

const LogConsole = ({ isGenerating, logovi, isFinished, ocistiKonzolu, logRef }) => {
    
    // Ovo osigurava da konzola uvek skroluje na dno kad stigne novi tekst
    useEffect(() => {
        if (logRef.current) {
            logRef.current.scrollTop = logRef.current.scrollHeight;
        }
    }, [logovi, logRef]);

    if (!isGenerating && !logovi) return null;

    return (
        <div ref={logRef} style={{
            marginTop: '40px', 
            padding: '15px', 
            backgroundColor: '#000', 
            color: '#00ff00', 
            fontFamily: 'monospace', 
            borderRadius: '5px', 
            border: '1px solid #333', 
            // ===========================
            // OVDE JE PROMENJENA VISINA
            height: '600px', 
            // ===========================
            overflowY: 'auto', 
            whiteSpace: 'pre-wrap', 
            position: 'relative'
        }}>
            <div style={{
                borderBottom: '1px solid #333', 
                marginBottom: '10px', 
                paddingBottom: '5px', 
                color: '#aaa', 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center', 
                position: 'sticky', 
                top: 0, 
                backgroundColor: '#000', 
                zIndex: 10
            }}>
                <span>KONZOLA SISTEMA: {isGenerating ? "IZVRŠAVANJE..." : "ZAVRŠENO"}</span>
                {isFinished && (
                    <button onClick={ocistiKonzolu} style={{
                        backgroundColor: '#ff4d4d', 
                        color: 'white', 
                        border: 'none', 
                        padding: '4px 12px', 
                        borderRadius: '4px', 
                        cursor: 'pointer', 
                        fontWeight: 'bold'
                    }}>
                        POTVRDI I ZATVORI
                    </button>
                )}
            </div>
            {logovi}
        </div>
    );
};

export default LogConsole;